import { Injectable } from '@angular/core';

import { CallLogService } from '@wephone-core/service/call_log_service';
import { ICallLog } from '@wephone-app-phone/pages/history/calllog.i';
import * as _ from 'lodash';

@Injectable()
export class HistoryService {
    constructor(private callLogService: CallLogService) {
    }

    getCallHistory(filters?: { start_dt: string, end_dt: string }): Promise<ICallLog[]> {
        return this.callLogService.getCallLogs(filters);
    }
}
